import { FormFieldMaskResponseDTO } from '@/api/base/DTOs';
import { FormMask } from '@/forms/typings';

export const adaptFormFieldMaskResponseToFormMask = (
  formFieldMaskResponse?: FormFieldMaskResponseDTO,
): FormMask | undefined => {
  return formFieldMaskResponse
    ? {
        mask: formFieldMaskResponse.mask,
        definitions: { ...formFieldMaskResponse.definitions },
      }
    : undefined;
};
